/*
 * Ryan O'Dowd
 * 2025-07-18
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import Button from '@components/common/Button';
import Icon from '@react-native-vector-icons/material-design-icons';
import NewSchoolDialog from '@website/components/NewSchoolDialog';
import getStyles from './styles';
import hooks from '@hooks';

const StartTrialButton = () => {
  const styles = hooks.useStyles(getStyles);

  const [_isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <React.Fragment>
      <Button
        style={styles.actionButton}
        contentStyle={styles.actionButtonText}
        theme={styles.colors.accent}
        onPress={() => setIsDialogOpen(true)}
        icon={() => <Icon name='cart' size={styles.globalScale * 20} color={styles.colors.primaryExtraDark} />}// @TODO: better icon
      >
        Start trial
      </Button>

      <NewSchoolDialog
        isOpen={_isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />

    </React.Fragment>
  );
};

export default StartTrialButton;
